export type FilterValue = string | string[] | undefined

/** Acceptable parameter values for URL construction */
export type ParamValue = string | number | boolean | string[] | undefined | null

export function constructUrlWithParams(
  basePath: string,

  paramsObject: Record<string, any>,
): string {
  const params = new URLSearchParams()

  const appendArrayParams = (key: string, values?: string[] | null) => {
    if (values?.length) {
      values.forEach((value) => {
        params.append(key, value)
      })
    }
  }

  Object.entries(paramsObject).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      appendArrayParams(key, value)
    } else if (value !== undefined && value !== null && value !== '') {
      params.append(key, String(value))
    }
  })

  return params.toString() ? `${basePath}?${params.toString()}` : basePath
}

export function normalizeFilter(
  filter: FilterValue,
): string | string[] | undefined {
  if (!filter) {
    return undefined
  }

  if (Array.isArray(filter)) {
    const normalized = filter
      .map((value) => value.trim())
      .filter((value) => value.length > 0)
      .sort()
    return normalized.length > 0 ? normalized : undefined
  }

  const normalized = filter.trim()
  return normalized.length > 0 ? normalized : undefined
}
